import { GridHookForm } from 'vnetwork-ui'
import { CUSTOMER_STATUS } from '@/modules/Customer/constants'
import { updateCustomerStatus } from '@/modules/Customer/services'
import { ModalProps } from '@/types/shared'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Alert, Dialog } from 'vnetwork-ui'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

export interface UnfollowLeadProps extends ModalProps {
    customer_id: number
    customer_name?: string
}

interface UnfollowLeadFormValues {
    customer_note: string
}

const UnfollowLead: React.FC<UnfollowLeadProps> = ({
    onClose,
    open,
    customer_id,
    customer_name,
}) => {
    const { t } = useTranslation()
    const formControl = useForm<UnfollowLeadFormValues>({
        defaultValues: {
            customer_note: '',
        },
        resolver: yupResolver(
            yup.object().shape({
                customer_note: yup.string().required(t('required')),
            })
        ),
    })

    const { mutateAsync, isPending } = useMutationWithHandler(
        {
            mutationFn: updateCustomerStatus,
        },
        {
            reactQueryKeys: QUERY_KEYS.CUSTOMERS,
            successMessage: t('customer:unfollow_lead_success'),
            onSuccess: () => {
                onClose()
            },
        }
    )

    const handleUnfollow = (values: UnfollowLeadFormValues) => {
        mutateAsync({
            customer_id,
            customer_status: CUSTOMER_STATUS.DEADLEAD,
            customer_note: values.customer_note,
        })
    }

    return (
        <Dialog
            title={t('customer:unfollow_lead')}
            onClose={onClose}
            open={open}
        >
            <Alert variant="warning">
                {t('customer:unfollow_lead_warning', { name: customer_name })}
            </Alert>
            <GridHookForm
                formControl={formControl}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'button',
                        variant: 'outlined',
                        handler: onClose,
                        disabled: isPending,
                    },
                    {
                        title: t('customer:unfollow_lead'),
                        type: 'submit',
                        variant: 'contained',
                        disabled: isPending,
                        loading: isPending,
                    },
                ]}
                data={[
                    {
                        className: 'md:col-span-4 col-span-1',
                        formItemProps: {
                            name: 'customer_note',
                            type: 'textarea',
                            placeholder: t('customer:unfollow_lead_reason'),
                            label: t('customer:unfollow_lead_reason') + ' *',
                        },
                    },
                ]}
                onSubmit={handleUnfollow}
                className="mt-4"
            />
        </Dialog>
    )
}

export default UnfollowLead
